import { useTranslation, Trans } from "react-i18next";

import i1 from '../../img/v1.svg';
import i2 from '../../img/v2.svg';
import i3 from '../../img/v3.svg';
import i4 from '../../img/v4.svg';

function OurValues() {
  const { t } = useTranslation();

  return (
    <>
      <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px]">
        <div className="flex flex-col xl:flex-row justify-between xl:items-center">
          <p className="host-grotesk leading-[1.2] xl:text-[64px] text-[#2A323F] text-[40px]">{t('about.17')}</p>
          <p className="xl:max-w-[600px] PtRoot text-[14px] xl:text-[16px] text-[#000000B2] mt-[20px] xl:mt-0"><Trans>{t('about.19')}</Trans></p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 mt-[40px] gap-[10px] xl:gap-[20px]">
          <div className="bg-[#E6E9EE] p-[20px] xl:h-[240px] rounded-[10px]">
            <img src={i1} alt="" />
            <p className="host-grotesk text-[16px] xl:text-[20px] text-[#2A323F] mt-[30px] xl:mt-[60px] leading-[1.2]">{t('about.20')}</p>
            <p className="mt-[5px] text-[#000000B2] PtRoot text-[12px] xl:text-[14px] xl:max-w-[238px]">{t('about.21')}</p>
          </div>
          <div className="bg-[#E6E9EE] p-[20px] xl:h-[240px] rounded-[10px]">
            <img src={i2} alt="" />
            <p className="host-grotesk text-[16px] xl:text-[20px] text-[#2A323F] mt-[30px] xl:mt-[60px] leading-[1.2]">{t('about.22')}</p>
            <p className="mt-[5px] text-[#000000B2] PtRoot text-[12px] xl:text-[14px] xl:max-w-[238px]">{t('about.23')}</p>
          </div>
          <div className="bg-[#E6E9EE] p-[20px] xl:h-[240px] rounded-[10px]">
            <img src={i3} alt="" />
            <p className="host-grotesk text-[16px] xl:text-[20px] text-[#2A323F] mt-[30px] xl:mt-[60px] leading-[1.2]">{t('about.24')}</p>
            <p className="mt-[5px] text-[#000000B2] PtRoot text-[12px] xl:text-[14px] xl:max-w-[258px]">{t('about.25')}</p>
          </div>
          <div className="bg-[#E6E9EE] p-[20px] xl:h-[240px] rounded-[10px]">
            <img src={i4} alt="" />
            <p className="host-grotesk text-[16px] xl:text-[20px] text-[#2A323F] mt-[30px] xl:mt-[60px] leading-[1.2]">{t('about.26')}</p>
            <p className="mt-[5px] text-[#000000B2] PtRoot text-[12px] xl:text-[14px] xl:max-w-[238px]">{t('about.27')}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default OurValues;
